import { useQuery } from "react-query";
import { ReferralApi } from "../../services";
export const useReferralStats = ({ uuid, ciam_token }) => {
    return useQuery("ReferralApi.getReferralStats", () => ReferralApi.init().getReferralStats(uuid, ciam_token), {
        enabled: Boolean(uuid && ciam_token),
        placeholderData: {
            earned_points: 0,
            referees_count: 0,
            completed_first_order_count: 0,
        },
    });
};
//# sourceMappingURL=useRefereralStats.js.map